export default theme => ({
    productGrid: {
        position: 'relative',
        marginBottom: 32,
    },
    productList: {

    }
})